export default {
    domain: 'https://www.jiushu1234.com',
};
